import Dio from '@guestyci/dio';
import config from 'config';
import { uuid } from '@guestyci/foundation/utils';

const VERIFICATION_STORAGE = {
  EMAIL: 'email-verification-reserve',
  USER_ID: 'user-id-verification-reserve',
  ACCOUNT_ID: 'account-id-verification-reserve',
};

export const DioContext = {
  REGISTRATION_V2: 'porter_registration_page_version2',
};

export const DioType = {
  PAGEVIEW: 'pageview',
  CLICK: 'click',
};

class DioInstance {
  #dioInstance = null;

  #accountId = null;

  get accountId() {
    return this.#accountId;
  }

  #userId = null;

  get userId() {
    return this.#userId;
  }

  #email = null;

  get email() {
    return this.#email;
  }

  constructor() {
    this.#dioInstance = Dio.init({
      context: DioContext.REGISTRATION_V2,
      baseUrl: config.dioBaseUrl,
      debug: process.env.NODE_ENV === 'development',
      // Note: All Dio instances on GFH projects use the "isPublic" flag. This uses a built-in
      // auth token stored in Dio itself, and doesn't require the JWT used by Guesty Pro (which
      // GFH doesn't have).
      isPublic: true,
    });

    this.#accountId =
      DioInstance.grabFromLocalStorage(VERIFICATION_STORAGE.ACCOUNT_ID) || `anon_${uuid()}`;
    this.#userId = DioInstance.grabFromLocalStorage(VERIFICATION_STORAGE.USER_ID);
    this.#email = DioInstance.grabFromLocalStorage(VERIFICATION_STORAGE.EMAIL);

    this.identify();
  }

  track(...args) {
    this.#dioInstance.track(...args);
  }

  identify() {
    this.#dioInstance.identify({
      accountId: this.accountId,
      userId: this.userId,
      email: this.email,
    });
  }

  updateIdentity({ accountId, email, userId }) {
    this.#email = email ?? this.#email;
    this.#userId = userId ?? this.#userId;
    this.#accountId = accountId ?? this.#accountId;

    this.identify();
  }

  storeAuthData() {
    DioInstance.setToLocalStorage(VERIFICATION_STORAGE.EMAIL, this.email);
    DioInstance.setToLocalStorage(VERIFICATION_STORAGE.USER_ID, this.userId);
    DioInstance.setToLocalStorage(VERIFICATION_STORAGE.ACCOUNT_ID, this.accountId);
  }

  static grabFromLocalStorage(key) {
    const result = localStorage.getItem(key);
    localStorage.removeItem(key);
    return result;
  }

  static setToLocalStorage(key, value) {
    localStorage.setItem(key, value);
  }
}

const dioInstance = new DioInstance();

export default dioInstance;
